// Wyoming State Parks (WyomingParks) booking strategy.
//
// Booking URL: passthrough of site.reserveUrl
// (https://reserve.wyoming.gov/web/Default.aspx#!park/{placeId}/{facilityId}
// — the campground's availability grid). No dynamic form exists: the hash
// router strips query params (probed ?startdate=... in discovery; the grid
// still loaded today's date), so nothing can be prefilled.
//
// Preview URL: the park-level overview page (#!park/{placeId}) listing
// every campground with availability counts. The site-level reserveUrl
// points at one campground's grid, which is too narrow for a
// "What does this park have?" preview when the Schnerp facility is the
// whole park.

export default {
  buildBookingUrl({ site }) {
    return site.reserveUrl;
  },

  buildPreviewUrl(site, facility) {
    const placeId = facility?.extraAttributes?.placeId;
    if (placeId) {
      return `https://reserve.wyoming.gov/web/Default.aspx#!park/${placeId}`;
    }
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "ignored",
          notes:
            "The USeDirect Web UI hash router strips query params; arrival date cannot be encoded (verified in discovery).",
        },
        departureDate: {
          status: "ignored",
          notes: "Not encodable — user picks dates in the campground grid.",
        },
        ref: {
          status: "ignored",
          notes:
            "site.reserveUrl already deep-links to the site's campground grid.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: "Party size is not encoded in the passthrough URL.",
        },
      },
    };
  },
};
